// RIA Settings config loader
// Loads hardcoded riaFirm + riaLabelSettings data based on current environment.
// These replace the following API calls which are no longer needed:
//   GET /serviceToken/v1/advisor/riaFirm/{riaId}
//   GET /serviceToken/v1/advisor/riaLabelSettings/{riaId}
//   GET /serviceToken/v1/advisor/riaFirm/riaUrl (removed - redundant)
import devRiaSettings from './dev';
import qaRiaSettings from './qa';
import prodRiaSettings from './prod';

const ENV = process.env.VUE_APP_ENV;

const getRiaSettingsForEnv = () => {
  if (ENV === 'qa') {
    return qaRiaSettings();
  }

  if (ENV === 'prod') {
    return prodRiaSettings();
  }

  // dev, local, and any other environment
  return devRiaSettings();
};

export default getRiaSettingsForEnv;
